import type { TCLTierName, SMOGTierName } from '../types';
import { tclTiers, smogTiers } from '../data/strategies';

export function calculateRiskPerTrade(accountSize: number, lifebarPercent: number): number {
  return accountSize * (lifebarPercent / 100);
}

export function determineTCLTier(trades: number, winRate: number): TCLTierName | null {
  if (trades >= 100 && winRate >= 0.76) return 'Hammer';
  if (trades >= 50 && winRate >= 0.73) return 'Sword';
  if (trades >= 20 && winRate >= 0.70) return 'Shield';
  return null;
}

export function determineSMOGTier(
  trades: number,
  avgWinner: number,
  monthsTrading: number,
): SMOGTierName | null {
  if (trades >= 10 && avgWinner >= 5.67 && monthsTrading >= 24) return 'Crossbow';
  if (trades >= 12 && avgWinner >= 4.0 && monthsTrading >= 12) return 'Longbow';
  if (trades >= 20 && avgWinner >= 3.0) return 'Sling';
  return null;
}

export function calculateExpectancy(
  winRate: number,
  avgWinner: number,
  avgLoser: number,
): number {
  return (winRate * avgWinner) - ((1 - winRate) * avgLoser);
}

export function isSMOGEligible(consistencyRulePercent: number | null): boolean {
  return consistencyRulePercent === null || consistencyRulePercent >= 0.50;
}

export function getLifebarPercent(strategy: 'TCL' | 'SMOG', tier: string): number {
  if (strategy === 'TCL') {
    return tclTiers[tier as TCLTierName]?.lifebarPercent ?? 1.0;
  }
  return smogTiers[tier as SMOGTierName]?.lifebarPercent ?? 6.5;
}

export function getTierColor(strategy: 'TCL' | 'SMOG', tier: string): string {
  if (strategy === 'TCL') {
    return tclTiers[tier as TCLTierName]?.color ?? '#4A9EFF';
  }
  return smogTiers[tier as SMOGTierName]?.color ?? '#3DBF7A';
}
